import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import { get } from 'lodash';
import { FontIcon, IconButton, LinearProgress, Tab, Tabs } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import DatePicker from 'react-datepicker';
import { connect, useSelector } from 'react-redux';
import { Col, Row } from 'react-flexbox-grid';
import pallet from '../../constants/colors';

import Loading from '../../components/Loading';
import PanelMessage from '../../components/panels/PanelMessage';
import PurchasesTable from './PurchasesTable';
import { initialize, changePeriod } from './actions';
import KTitle from '../../components/KJRN/KTitle';

const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  tab: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
  },
};

const Teria = ({
  teriaInitialize,
  setTimePeriod,
  start,
  end,
  error,
  hasError,
  initializeFailed,
}) => {
  const [activeTab, setActiveTab] = useState('CAFE');

  const {
    employeePurchases,
    guestPurchases,
    showStores,
    showCafes,
    loading,
    initializing,
    initialized,
  } = useSelector(state => state.teriaReducer);

  const showBothTabs = showCafes && showStores;
  const showCafeOnly = showCafes && !showStores;
  const showStoreOnly = !showCafes && showStores;

  const showBothTables = employeePurchases.length > 0 && guestPurchases.length > 0;
  const isDataEmpty = !loading && !employeePurchases.length && !guestPurchases.length;

  useEffect(() => {
    teriaInitialize();
  }, []);

  useEffect(() => {
    if (initialized) {
      if (showBothTabs || showCafeOnly) {
        setActiveTab('CAFE');
      }
      if (showStoreOnly) {
        setActiveTab('STORE');
      }
    }
  }, [initialized]);

  const getTitle = () => {
    if (showCafeOnly) return <FormattedMessage id="teria.cafeteria" />;
    if (showStoreOnly) return <FormattedMessage id="teria.store" />;
    return <FormattedMessage id="teria.title" />;
  };

  if (initializing) return <Loading />;

  if (initializeFailed || hasError) {
    return (
      <PanelMessage
        message={<FormattedMessage id="time.initialize.error" values={{ error }} />}
        iconName="error"
        type="error"
      />
    );
  }

  if (!showCafes && !showStores) {
    return (
      <PanelMessage
        message="Hvorki mötuneyti né verslun eru í notkun."
        iconName="error"
        type="error"
      />
    );
  }

  const isPeriod = moment(end).format('DD/MM/YYYY') === moment(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');

  const isMonth = (
    moment(start).format('DD/MM/YYYY') === moment(start).startOf('month').format('DD/MM/YYYY')
    && moment(end).format('DD/MM/YYYY') === moment(end).endOf('month').format('DD/MM/YYYY')
  );

  function handleActive(tab) {
    const type = tab.props.index === 0 ? 'CAFE' : 'STORE';
    setActiveTab(type);
    setTimePeriod(start, end, type);
  }

  const setLastPeriod = () => {
    if (isMonth) {
      setTimePeriod(moment(start).add(-1, 'month'), moment(end).add(-1, 'month').endOf('month'), activeTab);
    } else if (isPeriod) {
      setTimePeriod(moment(start).add(-1, 'month'), moment(start).add(-1, 'day'), activeTab);
    } else {
      const numberOfDays = moment(end).diff(start, 'days') + 1;
      setTimePeriod(moment(start).add(-numberOfDays, 'days'), moment(end).add(-numberOfDays, 'days'), activeTab);
    }
  };

  const setNextPeriod = () => {
    if (isMonth) {
      setTimePeriod(moment(start).add(1, 'month'), moment(end).add(1, 'month').endOf('month'), activeTab);
    } else if (isPeriod) {
      setTimePeriod(moment(start).add(1, 'month'), moment(start).add(2, 'month').add(-1, 'day'), activeTab);
    } else {
      const numberOfDays = moment(end).diff(start, 'days') + 1;
      setTimePeriod(moment(start).add(numberOfDays, 'days'), moment(end).add(numberOfDays, 'days'), activeTab);
    }
  };
  const setStartDate = (date) => {
    setTimePeriod(date, end);
  };

  const setEndDate = (date) => {
    setTimePeriod(start, date);
  };

  const dateColumn = {
    title: 'time.Date',
    dataIndex: 'PurchaseDateTime',
    width: 65,
    render: dataIndex => moment(dataIndex).format('DD.MM.YY'),
  };
  const priceColumn = {
    title: 'teria.price',
    dataIndex: 'Price',
    width: 65,
    render: dataIndex => <FormattedMessage id="ISK" values={{ amount: dataIndex }} />,
  };

  const employeeTable = {
    title: <FormattedMessage id="employee" />,
    key: 'TeriaEmployeeCafeteriaPurchaseID',
    columns: [
      dateColumn,
      { title: 'teria.cafeteria', dataIndex: 'CafeteriaName', width: 110 },
      priceColumn,
      { title: 'teria.cafeteria.type', dataIndex: 'IsGuestPurchase', render: isGuest => <FormattedMessage id={isGuest ? 'teria.cafeteria.employeeGuest' : 'employee'} /> },
    ]
  };
  const guestTable = {
    title: <FormattedMessage id="teria.guests" />,
    key: 'TeriaEmployeeCafeteriaCompanyGuestPurchaseID',
    columns: [
      dateColumn,
      { title: 'teria.cafeteria', dataIndex: 'CafeteriaName' },
      priceColumn,
    ]
  };
  const employeeTableStore = {
    title: <FormattedMessage id="teria.cafeteria" />,
    key: 'TeriaEmployeeStorePurchases',
    columns: [
      dateColumn,
      { title: 'teria.product', dataIndex: 'ProductName' },
      priceColumn,
      { title: 'teria.store', dataIndex: 'StoreName' },
    ]
  };

  const renderCafeteriaContent = (
    <Row style={{ maxWidth: 1400, margin: 'auto' }}>
      {isDataEmpty ? <div style={{ margin: 'auto', marginTop: 24 }}><FormattedMessage id="teria.noProducts" /></div> : null}
      {loading ? <LinearProgress mode="indeterminate" style={{ marginTop: 24 }} /> : null}
      <Col lg={showBothTables ? 6 : 12} md={12}>
        {employeePurchases.length ? <PurchasesTable table={employeeTable} entries={employeePurchases} showTitle={showBothTables} /> : null}
      </Col>
      <Col lg={showBothTables ? 6 : 12} md={12}>
        {guestPurchases.length ? <PurchasesTable table={guestTable} entries={guestPurchases} showTitle={guestPurchases.length > 0} /> : null}
      </Col>
    </Row>
  );

  const renderStoreContent = (
    <Row style={{ maxWidth: 1400, margin: 'auto' }}>
      {loading ? <LinearProgress mode="indeterminate" style={{ marginTop: 24 }} /> : null}
      {isDataEmpty ? <div style={{ margin: 'auto', marginTop: 24 }}><FormattedMessage id="teria.noProducts" /></div> : null}
      <Col lg={showBothTables ? 6 : 12} md={12}>
        {employeePurchases.length ? <PurchasesTable table={employeeTableStore} entries={employeePurchases} showTitle={showBothTables} /> : null}
      </Col>
    </Row>
  );

  return (
    <React.Fragment>
      <div>
        <KTitle containerStyle={{ maxWidth: 1400, margin: 'auto', marginTop: 12 }} key="hb" title={getTitle()} />
      </div>
      <Row middle="xs" center="xs">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            paddingTop: 12,
            justifyContent: 'space-between',
          }}
        >
          <IconButton onClick={setLastPeriod} style={{ marginRight: 12 }}>
            <FontIcon className="material-icons">arrow_back</FontIcon>
          </IconButton>
          <span style={{ fontSize: 18, fontWeight: 400 }}>
            <DatePicker
              className="smallPicker"
              selected={moment(start)}
              onChange={setStartDate}
              dateFormat="DD.MMM YYYY"
              selectsStart
              startDate={moment(start)}
              endDate={moment(end)}
            />
            {' - '}
            <DatePicker
              selected={moment(end)}
              onChange={setEndDate}
              dateFormat="DD.MMM YYYY"
              selectsEnd
              startDate={moment(start)}
              endDate={moment(end)}
              minDate={moment(start)}
            />
          </span>
          <IconButton onClick={setNextPeriod} style={{ marginLeft: 12 }}>
            <FontIcon className="material-icons">arrow_forward</FontIcon>
          </IconButton>
        </div>
      </Row>
      {showBothTabs && (
        <Tabs
          tabItemContainerStyle={{ backgroundColor: '#fff' }}
          inkBarStyle={{ backgroundColor: pallet.primary1Color }}
          style={{ paddingTop: 24, maxWidth: 1400, margin: 'auto' }}
        >
          <Tab
            className="Cafeteria"
            onActive={handleActive}
            style={{ ...styles.tab, color: `${activeTab === 'CAFE' ? 'rgb(0,0,0)' : 'rgba(0,0,0, 0.4)'}` }}
            label={<FormattedMessage id="teria.cafeteria" />}
          >
            {renderCafeteriaContent}
          </Tab>
          <Tab
            onActive={handleActive}
            style={{ ...styles.tab, color: `${activeTab === 'STORE' ? 'rgb(0,0,0)' : 'rgba(0,0,0, 0.4)'}` }}
            label={<FormattedMessage id="teria.store" />}
          >
            {renderStoreContent}
          </Tab>
        </Tabs>
      )}
      {showCafeOnly && renderCafeteriaContent}
      {showStoreOnly && renderStoreContent}
    </React.Fragment>
  );
};

Teria.propTypes = {
  teriaInitialize: PropTypes.func.isRequired,
  setTimePeriod: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  initializeFailed: PropTypes.bool.isRequired,
  start: PropTypes.shape({}).isRequired,
  end: PropTypes.shape({}).isRequired,
  error: PropTypes.string,
};

Teria.defaultProps = {
  error: null,
};

export default connect(
  ({ teriaReducer }) => ({ ...teriaReducer }),
  dispatch => ({
    teriaInitialize: () => dispatch(initialize()),
    setTimePeriod: (from, to, type) => dispatch(changePeriod(from, to, type)),
  }),
)(Teria);



// WEBPACK FOOTER //
// ./src/sites/teria/Teria.js